/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetUbiThirdPartyTermsResponse } from '../models/ApiResponseGetUbiThirdPartyTermsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UbiThirdPartyTermsControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 보험사 3자동의 및 고도화 동의 약관 조회
   * 보험사 3자동의 및 고도화 동의 약관 조회
   * @returns ApiResponseGetUbiThirdPartyTermsResponse OK
   * @throws ApiError
   */
  public getAgreements({
    vin,
    serviceId,
  }: {
    /**
     * Vehicle Identification Number (VIN)
     */
    vin: string,
    /**
     * 보험사 서비스 아이디
     */
    serviceId: string,
  }): CancelablePromise<ApiResponseGetUbiThirdPartyTermsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/third-party/ubi/cci/terms/',
      query: {
        'vin': vin,
        'serviceId': serviceId,
      },
    });
  }
  /**
   * 보험사 3자동의 및 고도화 동의 약관 조회
   * 보험사 3자동의 및 고도화 동의 약관 조회
   * @returns ApiResponseGetUbiThirdPartyTermsResponse OK
   * @throws ApiError
   */
  public getAgreements1({
    vin,
    serviceId,
  }: {
    /**
     * Vehicle Identification Number (VIN)
     */
    vin: string,
    /**
     * 보험사 서비스 아이디
     */
    serviceId: string,
  }): CancelablePromise<ApiResponseGetUbiThirdPartyTermsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/third-party/ubi/cci/terms',
      query: {
        'vin': vin,
        'serviceId': serviceId,
      },
    });
  }
}
